"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useClient = useClient;
var react_redux_1 = require("react-redux");
var client_1 = require("../api/client");
function useClient() {
    var user = (0, react_redux_1.useSelector)(function (state) { return state.userState; }).user;
    var clientId = user === null || user === void 0 ? void 0 : user.client_id;
    // a skipped hook keeps returning its last data, so currentData stops an ended session rendering the old client
    var _a = (0, client_1.useGetClientQuery)(clientId !== null && clientId !== void 0 ? clientId : "", { skip: !clientId }), client = _a.currentData, isLoading = _a.isLoading, isError = _a.isError, refetch = _a.refetch;
    return { client: client, isLoading: isLoading, isError: isError || !clientId, refetch: refetch };
}
